import { render, staticRenderFns } from "./IntegracoesApiNavegantes.vue?vue&type=template&id=207a1f1a&scoped=true"
import script from "./IntegracoesApiNavegantes.vue?vue&type=script&lang=js"
export * from "./IntegracoesApiNavegantes.vue?vue&type=script&lang=js"
import style0 from "./IntegracoesApiNavegantes.vue?vue&type=style&index=0&id=207a1f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207a1f1a",
  null
  
)

export default component.exports